<template>
  <MainLayout>

    <!-- Header moderno -->
    <PageHeader
      icon="ri-user-voice-line"
      title="Mis Tutorías"
      :subtitle="headerSubtitle"
      :show-button="true"
      button-text="Actualizar"
      button-icon="ri-loop-right-line"
      @action="actualizar"
    />

    <!-- Contenido Principal -->
    <div v-if="tutorias" class="content-container">
      <!-- Lista de Tutorías -->
      <div class="classes-collapsible-section">
        <div class="collapsible-header">
          <div class="collapsible-title">
            <i class="ri-team-line"></i>
            <h3>Tutorías Programadas</h3>
            <span v-if="tutorias.length > 0" class="badge-count">{{ tutorias.length }}</span>
          </div>
        </div>

        <div class="collapsible-content">
          <!-- Estado Vacío -->
          <div v-if="tutorias.length === 0" class="empty-state">
            <i class="ri-user-voice-line"></i>
            <p>No tienes tutorías pendientes</p>
            <span class="empty-subtitle">Programa tu primera tutoría para recibir apoyo personalizado</span>
          </div>

          <div v-else class="classes-list">
            <TutoriaProgramada
              v-for="(tutoria, index) in tutorias"
              :key="index"
              :tutoria="tutoria"
            />
          </div>

          <div v-if="textoPoliticaCancelacion" class="policy-alert">
            <i class="ri-error-warning-line"></i>
            <span>{{ textoPoliticaCancelacion }}</span>
          </div>

          <button class="btn-historic" @click="cargarHistorico">
            <i class="ri-time-line"></i>
            Ver histórico
          </button>
        </div>
      </div>

      <!-- Botón para programar nueva tutoría -->
      <router-link to="/tutoria" class="action-card">
        <div class="action-icon">
          <i class="ri-calendar-line"></i>
        </div>
        <div class="action-content">
          <h3>Programar Nueva Tutoría</h3>
          <p>Agenda tu próxima sesión de apoyo</p>
        </div>
        <i class="ri-arrow-right-line action-arrow"></i>
      </router-link>
    </div>

    <!-- Encuesta Modal -->
    <EncuestaTutoria 
      v-if="encuestaMostrar" 
      :agendamiento="agendamientoEncuesta" 
      @cerrar="actualizarEncuesta"
      :mostrar="encuestaMostrar" 
    />
  </MainLayout>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import utils from '@/modules/utils';
import TutoriaProgramada from '@/features/tutorias/components/TutoriaProgramada';

import EncuestaTutoria from '@/features/tutorias/components/EncuestaTutoria';
import MainLayout from '@/components/Layout/MainLayout.vue';
import PageHeader from '@/components/Layout/PageHeader.vue';

export default {
  name: 'MisTutoriasPage',
  components: {
    TutoriaProgramada,
    EncuestaTutoria,
    MainLayout,
    PageHeader
  },
  data() {
    return {
      agendamientoEncuesta: null,
      encuestas: null,
      isRefreshing: false
    }
  },
  mounted() {
    this.actualizar();
  },
  methods: {
    ...mapActions({
      verificarVariables: 'student/verificarVariables',
      fetchProgramaciones: 'student/fetchProgramaciones',
      fetchTutorias: 'tutoria/fetchTutorias',
      fetchEncuestas: 'tutoria/fetchEncuestas',
      cancelar: 'tutoria/cancelar'
    }),
    ...mapMutations({

    }),
    textoHora(value) {
      return utils.getTextoHora(value)
    },
    edit() {

    },
    actualizar() {
      this.isRefreshing = true;
      this.fetchProgramaciones();
      this.fetchTutorias();
      this.encuesta();
      this.verificarVariables().then((result) => {
        if (!this.tutoriasHabilitadas) {
          history.back()
        }
      });
      setTimeout(() => {
        this.isRefreshing = false;
      }, 1000);
    },
    cargarHistorico() {
      this.fetchTutorias({ history: true }).then(() => { })
    },
    encuesta() {
      this.fetchEncuestas().then((result) => {
        this.encuestas = result;
        if (this.encuestas && this.encuestas.length) {
          this.agendamientoEncuesta = this.encuestas[0];
        }
      })
    },
    actualizarEncuesta() {
      this.agendamientoEncuesta = null;
      this.actualizar();
    }
  },
  computed: {
    ...mapState({
      programaciones: state => state.student.programaciones,
      tutorias: state => state.tutoria.tutorias,
      ultima_actualizacion: state => state.tutoria.ultima_actualizacion,
      variables: state => state.student.variables,
    }),
    ...mapGetters({
      formattedClases: 'academico/formattedClases'
    }),
    tutoriasHabilitadas() {
      return this.variables && this.variables.habilitar_tutoria == 1 ? true : false;
    },
    textoPoliticaCancelacion() {
      const tutoriaConPolitica = this.tutorias.find(tutoria =>
        tutoria.estado !== 'cancelado' && tutoria.politica_cancel_mensaje
      );
      return tutoriaConPolitica ? tutoriaConPolitica.politica_cancel_mensaje : null;
    },
    lastTime() {
      if (this.ultima_actualizacion) {
        return this.ultima_actualizacion.toLocaleString() // 'es-CO', {timeZone:"America/Bogota"}
      }
      return null
    },
    zonaRegional() {
      const zonaVisible = this.userTimeZone === 'America/Bogota'
        ? 'América/Bogotá'
        : this.userTimeZone;
      return `(${zonaVisible})`;
    },
    encuestaMostrar() {
      if (this.agendamientoEncuesta && this.agendamientoEncuesta.clase) {
        if (this.agendamientoEncuesta.showEncuesta) {
          return true;
        }
      }
      return false;
    },
    userTimeZone() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    headerSubtitle() {
      if (this.lastTime) {
        return `Última actualización: ${this.lastTime} ${this.zonaRegional}`;
      }
      return 'Gestiona tus tutorías programadas';
    }
  }
}
</script>

<style scoped>
/* Container Principal - Usa variables globales */
.tutorias-modern {
  background: var(--theme-gradient-bg);
  min-height: calc(100vh - 70px);
  padding-bottom: 3rem;
  position: relative;
  overflow-x: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Efecto de fondo animado */
.tutorias-modern::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    var(--theme-radial-primary),
    var(--theme-radial-secondary),
    var(--theme-radial-accent);
  pointer-events: none;
  z-index: 0;
}

/* Acciones Rápidas */
.quick-actions {
  position: relative;
  z-index: 5;
  max-width: 1200px;
  margin: -1rem auto 2rem;
  padding: 0 2rem;
  display: flex;
  justify-content: flex-end;
}

.btn-nav-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  background: var(--theme-hover-bg-light);
  border: 1px solid var(--theme-border-color);
  border-radius: 10px;
  color: var(--theme-nav-text);
  font-weight: 500;
  font-size: 0.875rem;
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: var(--theme-backdrop-blur);
}

.btn-nav-link:hover {
  background: var(--theme-hover-bg);
  transform: translateY(-2px);
  text-decoration: none;
  color: var(--theme-nav-text);
}

.badge-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 0.5rem;
  background: rgba(13, 78, 140, 0.2);
  border: 1px solid rgba(13, 78, 140, 0.3);
  border-radius: 12px;
  color: var(--app-primary-blue);
  font-size: 0.75rem;
  font-weight: 600;
}

.tutorias-container {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Section Header */
.section-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--theme-border-color);
}

.section-header svg {
  color: var(--app-primary-blue);
  flex-shrink: 0;
}

.section-header h2 {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  color: var(--theme-text-primary);
}

/* Tutorías Grid */
.tutorias-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
}

/* Estado Vacío */
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 20px;
  backdrop-filter: var(--theme-backdrop-blur);
  box-shadow: var(--theme-shadow-md);
  margin-bottom: 2rem;
}

.empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 96px;
  background: rgba(13, 78, 140, 0.15);
  border-radius: 24px;
  margin: 0 auto 1.5rem;
  color: var(--app-primary-blue);
}

.empty-state h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--theme-text-primary);
  margin: 0 0 0.5rem 0;
}

.empty-state p {
  font-size: 1rem;
  color: var(--theme-text-secondary);
  margin: 0;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

/* Botones de Acción */
.action-buttons {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.btn-primary,
.btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: none;
  text-decoration: none;
  flex: 1;
  min-width: 200px;
}

.btn-primary {
  background: var(--theme-gradient-primary);
  color: white;
  box-shadow: 0 4px 16px rgba(13, 78, 140, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(13, 78, 140, 0.4);
  color: white;
  text-decoration: none;
}

.btn-secondary {
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  color: var(--theme-text-primary);
  backdrop-filter: var(--theme-backdrop-blur);
}

.btn-secondary:hover {
  background: var(--theme-hover-bg);
  transform: translateY(-2px);
  box-shadow: var(--theme-shadow-md);
}

/* Responsive */
@media (max-width: 768px) {
  .tutorias-modern {
    padding-bottom: 2rem;
  }
  
  .quick-actions {
    margin: -0.5rem auto 1.5rem;
    padding: 0 1rem;
  }
  
  .btn-nav-link {
    flex: 1;
  }
  
  .section-header h2 {
    font-size: 1.25rem;
  }
  
  .empty-state {
    padding: 3rem 1.5rem;
  }
  
  .empty-icon {
    width: 80px;
    height: 80px;
  }
  
  .empty-icon svg {
    width: 48px;
    height: 48px;
  }
  
  .empty-state h3 {
    font-size: 1.25rem;
  }
  
  .action-buttons {
    flex-direction: column;
  }
  
  .btn-primary,
  .btn-secondary {
    width: 100%;
    min-width: auto;
  }
}

@media (max-width: 480px) {
  .quick-actions {
    padding: 0 0.75rem;
    margin: -0.5rem auto 1.25rem;
  }
  
  .btn-nav-link {
    padding: 0.5rem 0.75rem;
    font-size: 0.8125rem;
  }
  
  .btn-nav-link svg {
    width: 16px;
    height: 16px;
  }
  
  .section-header {
    margin-bottom: 1rem;
  }
  
  .section-header svg {
    width: 20px;
    height: 20px;
  }
  
  .section-header h2 {
    font-size: 1.1rem;
  }
  
  .empty-state {
    padding: 2rem 1rem;
  }
  
  .empty-icon {
    width: 64px;
    height: 64px;
  }
  
  .empty-icon svg {
    width: 36px;
    height: 36px;
  }
  
  .empty-state h3 {
    font-size: 1.1rem;
  }
  
  .empty-state p {
    font-size: 0.875rem;
  }
  
  .btn-primary,
  .btn-secondary {
    padding: 0.875rem 1.5rem;
    font-size: 0.9375rem;
  }
}

/* Shared visual language with MisClases */
.content-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.classes-collapsible-section {
  position: relative;
  z-index: 1;
  overflow: hidden;
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 20px;
  box-shadow: var(--theme-shadow-md);
  animation: fadeInUp 0.6s ease-out 0.2s both;
}

.collapsible-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 2rem;
  background: var(--theme-bg-card);
}

.collapsible-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: var(--theme-text-primary);
}

.collapsible-title > i {
  color: var(--app-color-cyan-light);
  font-size: 1.5rem;
}

.collapsible-title h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}

.badge-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 0.5rem;
  background: var(--theme-gradient-success);
  color: white;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 700;
  box-shadow: var(--theme-shadow-sm);
}

.collapsible-content {
  padding: 0 2rem 2rem;
  border-top: 1px solid var(--theme-border-color);
}

.classes-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 3rem 2rem;
  margin: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.empty-state > i {
  margin-bottom: 0.5rem;
  color: var(--theme-text-secondary);
  font-size: 3.5rem;
  opacity: 0.5;
}

.empty-state p {
  margin: 0;
  color: var(--theme-text-primary);
  font-size: 1.1rem;
  font-weight: 600;
}

.empty-subtitle {
  color: var(--theme-text-secondary);
  font-size: 0.9rem;
  font-weight: 500;
  text-align: center;
}

.policy-alert {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.5rem 0.625rem;
  margin-top: 1rem;
  background: var(--theme-hover-bg-light);
  border: 1px solid var(--theme-border-color);
  border-radius: 6px;
  color: var(--theme-text-primary);
  font-size: 0.75rem;
  line-height: 1.4;
}

.policy-alert i {
  flex-shrink: 0;
  margin-top: 0.125rem;
  color: var(--app-primary-blue);
  font-size: 1rem;
}

.btn-historic {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  margin-top: 1rem;
  background: var(--theme-hover-bg-light);
  border: 1px solid var(--theme-border-color);
  border-radius: 10px;
  color: var(--theme-text-secondary);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-historic:hover {
  background: var(--theme-hover-bg);
  color: var(--theme-text-primary);
  transform: translateY(-2px);
}

.action-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  overflow: hidden;
  padding: 2rem;
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 20px;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out 0.3s both;
}

.action-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: var(--theme-gradient-primary);
  transition: width 0.3s ease;
}

.action-card:hover {
  color: inherit;
  text-decoration: none;
  transform: translateY(-4px);
  border-color: var(--theme-border-color-strong);
  box-shadow: var(--theme-shadow-lg);
}

.action-card:hover::before {
  width: 8px;
}

.action-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  background: var(--theme-gradient-primary);
  border-radius: 16px;
  color: white;
  font-size: 1.75rem;
  transition: transform 0.3s ease;
}

.action-card:hover .action-icon {
  transform: scale(1.1) rotate(5deg);
}

.action-content {
  flex: 1;
}

.action-content h3 {
  margin: 0 0 0.5rem;
  color: var(--theme-text-primary);
  font-size: 1.25rem;
  font-weight: 600;
}

.action-content p {
  margin: 0;
  color: var(--theme-text-secondary);
  font-size: 0.9rem;
}

.action-arrow {
  color: var(--theme-text-secondary);
  font-size: 1.5rem;
  transition: all 0.3s ease;
}

.action-card:hover .action-arrow {
  color: var(--theme-text-primary);
  transform: translateX(5px);
}

@media (max-width: 768px) {
  .content-container {
    padding: 1.5rem;
  }

  .collapsible-header {
    padding: 1.25rem 1.5rem;
  }

  .collapsible-content {
    padding: 0 1.5rem 1.5rem;
  }

  .empty-state {
    padding: 2.5rem 1.5rem;
  }

  .action-card {
    padding: 1.5rem;
  }

  .action-icon {
    width: 50px;
    height: 50px;
    font-size: 1.5rem;
  }

  .action-content h3 {
    font-size: 1.1rem;
  }

  .action-content p {
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .content-container {
    padding: 1rem;
  }

  .collapsible-header {
    padding: 1rem 1.25rem;
  }

  .collapsible-title {
    gap: 0.5rem;
  }

  .collapsible-title h3 {
    font-size: 1rem;
  }

  .collapsible-title > i {
    font-size: 1.25rem;
  }

  .collapsible-content {
    padding: 0 1.25rem 1.25rem;
  }

  .empty-state {
    padding: 2rem 1rem;
  }

  .empty-state > i {
    font-size: 2.5rem;
  }

  .empty-state p {
    font-size: 0.95rem;
  }

  .empty-subtitle {
    font-size: 0.8rem;
  }

  .classes-list {
    gap: 0.75rem;
    margin-top: 1rem;
  }

  .btn-historic {
    padding: 0.625rem 1.25rem;
    font-size: 0.875rem;
  }

  .action-card {
    gap: 1rem;
    padding: 1.25rem;
  }

  .action-icon {
    width: 45px;
    height: 45px;
    font-size: 1.35rem;
  }

  .action-content h3 {
    font-size: 1rem;
  }

  .action-content p {
    font-size: 0.8rem;
  }

  .action-arrow {
    font-size: 1.25rem;
  }
}
</style>